import { gql } from 'apollo-boost'

const START_SCRAPING_SESSION = gql`
  mutation startScrapingSession(
    $tagGroupIds: [ID!]!
    $isDebugModeScraping: Boolean!
    $scrapingType: ScrapingType
    $scrapingSettings: Object
  ) {
    startScrapingSession(
      tagGroupIds: $tagGroupIds
      isDebugModeScraping: $isDebugModeScraping
      scrapingType: $scrapingType
      scrapingSettings: $scrapingSettings
    )
  }
`

export default START_SCRAPING_SESSION
